
// #727: "Who referred you?" for a visitor with no paying source in an open
// state. Controlled: emits the whole object on every change.
export default {
    name: 'ReferredByPicker',
    props: { value: { type: Object, required: true } },
    methods: {
        set (k, v) { this.$emit('input', { ...this.value, [k]: v }) },
        setType (t) { if (this.value.type !== t) this.set('type', t) },
    },
}
